import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Logo from "@/assets/images/logo.png?inline";
import LogoWhite from "@/assets/images/logo_white.png?inline";
import { ThemeSwitcher } from "@/atoms";
import { routesUrlsData } from "@/data";
import { ThemeEnum } from "@/enums";
import { useTheme } from "@/hooks";
import { HeaderInterface } from "@/interfaces";

export const BlankHeader = () => {
    const { theme } = useTheme();

    const rootReducer = useSelector((state) => state as { header?: HeaderInterface });

    return (
        <div className="flex h-[104px] flex-col items-center justify-between gap-2 bg-card p-3 md:flex-row md:px-6 md:py-0">
            <Link
                className="flex-1"
                to={routesUrlsData.home}
            >
                <img
                    alt="logo"
                    height={40}
                    src={theme === ThemeEnum.DARK ? LogoWhite : Logo}
                    width={163}
                />
            </Link>
            <div className="flex items-center justify-end gap-3 md:gap-6">
                {rootReducer?.header?.otherData}
                <ThemeSwitcher />
            </div>
        </div>
    );
};
